import { Bookmark, BookmarkOutline } from '@lyearn/icons';

export const BOOKMARKED_CONFIG = {
  label: 'ContentCards.RemoveBookmark',
  Icon: Bookmark,
};

export const NOT_BOOKMARKED_CONFIG = {
  label: 'ContentCards.Bookmark',
  Icon: BookmarkOutline,
};

export const APPEARANCE_CLASSES = {
  primary: 'text-icon-active',
  inverse: 'text-icon-white',
};
